<template>
	<div class="">
		<table class="infotable">
			<tbody>
				<tr v-for="(row, index) in pagedata.tableRows" :key="index">
					<td v-for="(cell, cindex) in row" :key="cindex" class="infotable-cell">
						{{ cell }}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import {store} from '@/store.js'
import {globalMixin} from "@/mixins"
export default {
	name: 'CRAInfDialInfoTable',
	mixins: [globalMixin],
	components: {

	},
	props: {
		pagedata: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			store: store,



		}
	},
	computed: {

	},
	methods: {

	},
	watch: {
		// pagedata() {
		// 	if(this.pagedata) this.prepData()
		// },
	},
	mounted() {
		// if(this.pagedata) this.prepData()
	},
	created() {

	},
}
</script>

<style scoped>
.infotable {
	width: 100%;
	border-collapse: collapse;
}
.infotable-cell {
	border: 1px solid #DDD;
	padding: 10px 15px;
	font-size: 16px;
	text-align: left;
}
</style>
